import { DgtPdOrderPicklistMovement } from "../models";
import { useState, useEffect, useMemo } from 'react'
import { PicklistStatus, MaterialType } from '../constants/EnumType'
import { getDates } from '../utilities/Format'
import {
  getIssuedMovements,
  getPdCheckeddMovements
} from '../states/PicklistAction'

export default function usePicklistMovements(
  status: string,
  orderType: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string,
) : [ DgtPdOrderPicklistMovement[], (updatedMovement: DgtPdOrderPicklistMovement) => void] {
  const [movements, setMovements] = useState<DgtPdOrderPicklistMovement[]>([]);

  const mutateMovement = (updatedMovement: DgtPdOrderPicklistMovement) => {
    const latestMovements = movements.map(
      mv => mv.id === updatedMovement.id ? updatedMovement : mv)
    if (status === PicklistStatus.WH_APPROVED) {
      setMovements(latestMovements.filter(
        mv => !mv.checkedDateTime)
      )
    } else if (status === PicklistStatus.PD_CHECKED) {
      setMovements(latestMovements.filter(
        mv => mv.checkedDateTime && mv.checkedDateTime > 0)
      )
    }
  }

  useEffect(() => {
    if (!Object.values(MaterialType).includes(orderType as MaterialType)) {
      return
    }
    const periodDates = getDates(dateFrom, dateTo)

    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.WH_APPROVED) {
        return getIssuedMovements(date, division, orderType)
      } else if (status === PicklistStatus.PD_CHECKED) {
        return getPdCheckeddMovements(date, division, orderType)
      }
      // don't need case wh-shortage
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalMvs = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklistMovement[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklistMovement[])
      setMovements(totalMvs)
    })
    .catch(err => console.error(err))
    
  }, [ status, orderType, dateFrom, dateTo, division ])

  const filteredMvs = useMemo(() => movements.filter(mv => mv.materialCode.includes(searchByOrder)), [ searchByOrder, movements ])
  return [ filteredMvs, mutateMovement ]
}